import { FC, useState, useRef } from 'react';
import { useTrans } from 'base/utils/i18n';
import { ReferralTitle } from 'mod/referral/ReferralTitle';
import site from 'pro/config/site';
import { Collapse } from '@base/lib/Collapse';
import { scrollToAnchor } from 'base/utils/scrollTo';
import { observer, useStoreState } from 'base/store';
import { HtmlRender } from '@base/snippets/HtmlRender';

type IReferralFAQsProps = {
    className?: string;
};

type IFAQItem = { question: string; answer: string };

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

export const ReferralFAQs: FC<IReferralFAQsProps> = observer((props) => {
    const { className } = props;
    const { t } = useTrans();
    const [visible, setVisible] = useState<boolean>(!isPhone);
    const contaierRef = useRef<HTMLDivElement>(null);
    const { referralConfig } = useStoreState('persistStore')
    const userStore = useStoreState('userStore');
    const { pointsRule } = userStore

    let list: IFAQItem[];
    try {
        let listStr = t('web_referral_faqs_list', {
            obtainPoints: +pointsRule.obtainPoints * referralConfig.referralPointsPercent,
            obtainPointsPrice: pointsRule.obtainPointsPrice,
            consumePoints: pointsRule.consumePoints,
            consumePointsPrice: pointsRule.consumePointsPrice,
            brand: site.brand
        });
        listStr = listStr.replace(/\\+/g, '\\');
        list = JSON.parse(listStr) as IFAQItem[];
    } catch (e) {
        console.log(e)
        list = [];
    }

    return (
        <div className={className} ref={contaierRef}>
            <ReferralTitle>{t('web_referral_faqs', { brand: site.brand })}</ReferralTitle>
            <Collapse
                accordion
                defaultValue={['0']}
                list={list.map((item, index) => ({
                    key: String(index),
                    title: item.question,
                    style: { display: isPhone && index > 2 && !visible ? 'none' : 'block' },
                    body: <HtmlRender html={item.answer}/>
                }))}
            />

            {isPhone && list.length > 3 && (
                <div
                    className={'g-more'}
                    onClick={() => {
                        setVisible(!visible);
                        if (visible) {
                            scrollToAnchor({
                                selector: contaierRef.current as HTMLDivElement
                            })
                        }
                    }}
                >
                    {t(visible ? 'web_common_view_less' : 'web_common_view_more')} &gt;
                </div>
            )}
        </div>
    )
});
